import { CONSTANTS } from "../constants/constants";
import { BRANDS, LANGUAGES } from "../models/screen-size.enum";

export const getGraphQLBaseUrl = (url: string): string => {
  const brandName = url.includes(BRANDS.KWIKSETUNITE) ? CONSTANTS.KWIKSETUNITE_GRAPHQL : CONSTANTS.WEISERUNITE_GRAPHQL;
  if (window.__dev__) console.log("api-url -> brandName:", brandName);
  return brandName;
};
